import { render, staticRenderFns } from "./AddSalaryTemplate.vue?vue&type=template&id=2178cb76&scoped=true&"
import script from "./AddSalaryTemplate.vue?vue&type=script&lang=js&"
export * from "./AddSalaryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddSalaryTemplate.vue?vue&type=style&index=0&id=2178cb76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178cb76",
  null
  
)

export default component.exports